import LaporanFakturPenjualan from "./LaporanFakturPenjualan";

export default LaporanFakturPenjualan;
